import { render, staticRenderFns } from "./ui-carousel.vue?vue&type=template&id=2bb04b69&scoped=true"
import script from "./ui-carousel.vue?vue&type=script&lang=js"
export * from "./ui-carousel.vue?vue&type=script&lang=js"
import style0 from "./ui-carousel.vue?vue&type=style&index=0&id=2bb04b69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb04b69",
  null
  
)

export default component.exports